import { Text, View, type StyleProp, type TextStyle } from "react-native";
import { useTranslation } from "react-i18next";
import type { ModelDayFit } from "@heraion/shared";

import type { UiTheme } from "../theme";

// #413, #492 F3: what the minutes cost, under the minutes chips: the rows the
// fit cut, in one line, and the warning when a day still runs over. Mounted
// empty so a change is announced; RNW maps the prop to aria-live.
export function ModelWizardCut({
  theme,
  fit,
  cutCount,
  minutes,
  listed,
  hintStyle,
}: {
  theme: UiTheme;
  fit: readonly ModelDayFit[];
  /** The rows the fit took out whole (useModelWizardFit's `cut`). */
  cutCount: number;
  minutes: number;
  /** The days are listed below (not in follow mode): the line points at them. */
  listed: boolean;
  hintStyle: StyleProp<TextStyle>;
}) {
  const { t } = useTranslation();
  const spaced = [hintStyle, { marginTop: theme.spacing.s2 }];
  return (
    <View accessibilityLiveRegion="polite">
      {cutCount > 0 ? (
        <Text style={spaced}>
          {listed
            ? t("programModel.wizard.cut.summary", {
                count: cutCount,
                minutes,
                defaultValue:
                  "{{minutes}} min leave out {{count}} exercises, struck through below. Put one back: another leaves in its place.",
              })
            : t("programModel.wizard.cut.summaryCount", {
                count: cutCount,
                minutes,
                defaultValue: "{{minutes}} min leave out {{count}} exercises.",
              })}
        </Text>
      ) : null}
      {fit.some((d) => d.overBudget) ? (
        <Text style={spaced}>
          {t("editorV3.model.minutesOver", {
            defaultValue: "Warning: on some days the time you asked for cannot be kept.",
          })}
        </Text>
      ) : null}
    </View>
  );
}
